import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { PagerSettings } from '../../models/pagerSettings';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-pager',
    templateUrl: './pager.component.html',
    styleUrls: ['./pager.component.scss'],
    standalone: false
})
export class PagerComponent implements OnInit, OnDestroy {
  private readonly unsubscribe = new Subject<boolean>();

  @Input()
  set pagerSettings(val) {
    this.initializePager(val);
  };
  @Input() entitiesName: string;

  currentPage: number;
  maxPageCount: number;
  availableItems: number;
  totalItems: number;
  pageSize: number;

  @Output() currentPageChanged = new EventEmitter<number>();

  constructor() { }

  ngOnInit() { }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  initializePager(pagerSettings: PagerSettings) {
    if (pagerSettings) {
      this.currentPage = pagerSettings.currentPage;
      this.maxPageCount = Math.ceil(pagerSettings.totalAvailableItems / pagerSettings.pageSize);
      this.availableItems = pagerSettings.availableItems;
      this.totalItems = pagerSettings.totalAvailableItems;
      this.pageSize = pagerSettings.pageSize;
      if (this.totalItems === 0) {
        this.currentPage = 0;
      }
    }
  }

  selectPreviousPage() {
    if (this.canSelectPreviousPage()) {
      this.currentPage--;
      this.pushPageChangeEvent();
    }
  }

  selectNextPage() {
    if (this.canSelectNextPage()) {
      this.currentPage++;
      this.pushPageChangeEvent();
    }
  }

  canSelectPreviousPage() {
    return this.currentPage > 1;
  }

  canSelectNextPage() {
    return this.currentPage < this.maxPageCount;
  }

  onCurrentPageChanged(event: any) {
    const oldCurrentPage = this.currentPage;

    if (event.target.value) {
      const currentPage = +event.target.value;
      if (currentPage >= 1 && currentPage <= this.maxPageCount && currentPage !== oldCurrentPage) {
        this.currentPage = currentPage;
        this.pushPageChangeEvent();
      }
      else {
        this.currentPage = oldCurrentPage;
        event.target.value = this.currentPage;
      }
    }
    else {
      this.currentPage = oldCurrentPage;
      event.target.value = this.currentPage;
    }
  }

  pushPageChangeEvent() {
    this.currentPageChanged.emit(this.currentPage);
  }
}
